<template>
    <div class="register bg-cover bg-center bg-no-repeat pt-40 pb-20 z-10">
        <div
            class="relative flex flex-col items-center max-w-screen-sm mx-auto pb-56 md:pb-0"
        >
            <SpriteAnim
                v-if="!$isMobile()"
                id="senalandoTop"
                :json="
                    require('../../assets/animations/panchito_top_right-min.json')
                "
                :png="
                    require('../../assets/animations/panchito_top_right-min.png')
                "
                :fps="24"
                class="paco"
            />

            <div class="flex flex-col items-center mb-12">
                <brush-stroke-bg>
                    <h2
                        class="font-primary text-3xl text-white font-semibold py-2 pr-6"
                    >
                        {{ $config("SELECT_PLAN") }}
                    </h2>
                </brush-stroke-bg>
            </div>

            <div class="flex mb-6">
                <div class="mr-4">
                    <btn
                        class="bg-orange text-white lowercase sm:px-6"
                        @click="selectPlan('MONTH')"
                        >{{ $config("MONTH_PRICE") }} / {{ $config("MES") }}
                    </btn>
                </div>

                <div class="flex flex-col items-end">
                    <btn
                        class="bg-light-blue text-white lowercase mb-2 sm:px-6"
                        @click="selectPlan('YEAR')"
                        >{{ $config("YEAR_PRICE") }} / {{ $config("ANO") }}
                    </btn>
                    <span
                        class="font-secondary text-blue-lighter font-semibold text-xs"
                        v-html="$config('AHORRA')"
                    ></span>
                </div>
            </div>

            <div
                class="flex items-start sm:w-1/2 mb-8 font-secondary text-lg text-blue-light"
            >
                <ul>
                    <li class="flex items-center mb-1">
                        <app-image
                            url="check-blue.png"
                            is-local
                            :try-webp="false"
                            class="w-10 mr-2"
                        ></app-image>
                        {{ $config("P_ACCESO") }}
                    </li>
                    <li class="flex items-center mb-1">
                        <app-image
                            url="check-blue.png"
                            is-local
                            :try-webp="false"
                            class="w-10 mr-2"
                        ></app-image>
                        {{ $config("P_DISPOSITIVO") }}
                    </li>
                    <li class="flex items-center mb-1">
                        <app-image
                            url="check-blue.png"
                            is-local
                            :try-webp="false"
                            class="w-10 mr-2"
                        ></app-image>
                        {{ $config("P_CANCELAR") }}
                    </li>
                    <li class="flex items-center mb-1">
                        <app-image
                            url="check-blue.png"
                            is-local
                            :try-webp="false"
                            class="w-10 mr-2"
                        ></app-image>
                        {{ $config("FREETRIAL") }}
                    </li>
                </ul>
            </div>

            <div class="flex flex-col items-center">
                <btn
                    class="rounded-large bg-yellow hover:bg-yellow-dark text-white mb-4 sm:px-6"
                    @click="subscribe"
                    >{{ subscribeText }}
                </btn>

                <p class="font-secondary text-xs font-semibold text-blue-light">
                    {{ $config("P_TEST") }}
                </p>
            </div>
            <app-image
                v-if="$isMobile()"
                :url="
                    require('../../assets/animations/panchito_top_right_fallback-min.png')
                "
                :is-local="false"
                alt="Linea de tiempo precio"
                class="paco"
                :try-webp="false"
                style="margin-bottom: -150px;"
                width="250"
            >
            </app-image>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import allowLimitedAccessOnly from "../../mixins/allowLimitedAccessOnly";
import BrushStrokeBg from "../../components/BrushStrokeBg";
import Btn from "../../components/Btn";
import SpriteAnim from "../../components/SpriteAnim";

export default {
    name: "register-select-plan",

    components: { BrushStrokeBg, Btn, SpriteAnim },

    mixins: [allowLimitedAccessOnly],

    methods: {
        ...mapMutations({
            selectPlan: "SET_SELECTED_PLAN"
        }),

        subscribe() {
            this.$router.push({ name: "register-payment" }, () => {});
        }
    },

    computed: {
        ...mapState({
            selectedPlan: "selectedPlanForRegistration"
        }),

        ...mapGetters(["selectedPlanPrice", "selectedPlanCycle"]),

        subscribeText() {
            return `${this.$config("SUBSCRIBE")} ${this.selectedPlanPrice} / ${
                this.selectedPlanCycle
            }`;
        }
    }
};
</script>

<style lang="scss" scoped>
.register {
    background-image: url("~@/assets/img/fondos_pinguiigluu.jpg");
}

.paco {
    bottom: 0;
    left: -10%;

    @media (max-width: 767px) {
        left: 10px;
        bottom: -70px;
    }
}
</style>
